export default {
  CREATE_TOUR: {
    pending: 'CREATE_TOUR/pending',
    fulfilled: 'CREATE_TOUR/fulfilled',
    rejected: 'CREATE_TOUR/rejected',
  },
  GET_TOUR_LIST: {
    pending: 'GET_TOUR_LIST/pending',
    fulfilled: 'GET_TOUR_LIST/fulfilled',
    rejected: 'GET_TOUR_LIST/rejected',
  },
  GET_TOUR_BY_ID: {
    pending: 'GET_TOUR_BY_ID/pending',
    fulfilled: 'GET_TOUR_BY_ID/fulfilled',
    rejected: 'GET_TOUR_BY_ID/rejected',
  },
  DELETE_PHOTO_TOUR:{
    pending: 'DELETE_PHOTO_TOUR/pending',
    fulfilled: 'DELETE_PHOTO_TOUR/fulfilled',
    rejected: 'DELETE_PHOTO_TOUR/rejected',
  },
  ADD_PHOTO_TOUR:{
    pending: 'ADD_PHOTO_TOUR/pending',
    fulfilled: 'ADD_PHOTO_TOUR/fulfilled',
    rejected: 'ADD_PHOTO_TOUR/rejected',
  },
  UPLOAD_TOUR_VIDEO:{
    pending: 'UPLOAD_TOUR_VIDEO/pending',
    fulfilled: 'UPLOAD_TOUR_VIDEO/fulfilled',
    rejected: 'UPLOAD_TOUR_VIDEO/rejected',
  },
  DELETE_TOUR_VIDEO: {
    pending: 'DELETE_TOUR_VIDEO/pending',
    fulfilled: 'DELETE_TOUR_VIDEO/fulfilled',
    rejected: 'DELETE_TOUR_VIDEO/rejected',
  },
  EDIT_TOUR: {
    pending: 'EDIT_TOUR/pending',
    fulfilled: 'EDIT_TOUR/fulfilled',
    rejected: 'EDIT_TOUR/rejected',
  },
  DELETE_TOUR:{
    pending: 'DELETE_TOUR/pending',
    fulfilled: 'DELETE_TOUR/fulfilled',
    rejected: 'DELETE_TOUR/rejected',
  },
  CHANGE_TOUR_DATA: 'CHANGE_TOUR_DATA',
  TOGGLE_SHOW_POPUP: 'TOGGLE_SHOW_POPUP',
  CLEAN_EDIT_TOUR_STATE: 'CLEAN_EDIT_TOUR_STATE',
}


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/ActionTypes.js